import { z } from "zod";
import {
  ZodErrorMessageEnumValue,
  SeverityEnumSchema,
  TrendEnumSchema,
  ImpactEnumSchema,
  ProbabilityEnumSchema,
  StatusEnumSchema,
} from "./enums.js";

export const createRiskSchema = z.object({
  riskNameId: z.string({
    required_error: ZodErrorMessageEnumValue.REQUIRED,
  }),
  type: z.string({
    required_error: ZodErrorMessageEnumValue.REQUIRED,
  }),
  title: z.string({
    required_error: ZodErrorMessageEnumValue.REQUIRED,
  }),
  description: z.string().max(10000).optional(),
  impact: z.nativeEnum(ImpactEnumSchema, {
    required_error: ZodErrorMessageEnumValue.REQUIRED,
  }),
  probability: z.nativeEnum(ProbabilityEnumSchema, {
    required_error: ZodErrorMessageEnumValue.REQUIRED,
  }),
  consequences: z.string().max(10000).optional(),
  severity: z.nativeEnum(SeverityEnumSchema, {
    required_error: ZodErrorMessageEnumValue.REQUIRED,
  }),
  trend: z.nativeEnum(TrendEnumSchema, {
    required_error: ZodErrorMessageEnumValue.REQUIRED,
  }),
  status: z.nativeEnum(StatusEnumSchema, {
    required_error: ZodErrorMessageEnumValue.REQUIRED,
  }),
  preventiveMeasure: z.string().max(10000).optional(),
  correctiveMeasure: z.string().max(10000).optional(),
  projectId: z.string({
    required_error: ZodErrorMessageEnumValue.REQUIRED,
  }),
  responsibleUserId: z.string().uuid().nullable().optional(),
});

export const updateRiskSchema = z.object({
  riskNameId: z.string().optional(),
  type: z.string().optional(),
  title: z.string().optional(),
  description: z.string().max(10000).optional(),
  impact: z.nativeEnum(ImpactEnumSchema).optional(),
  probability: z.nativeEnum(ProbabilityEnumSchema).optional(),
  consequences: z.string().optional(),
  severity: z.nativeEnum(SeverityEnumSchema).optional(),
  trend: z.nativeEnum(TrendEnumSchema).optional(),
  preventiveMeasure: z.string().optional(),
  correctiveMeasure: z.string().optional(),
  projectId: z.string().optional(),
  responsibleUserId: z.string().uuid().nullable().optional(),
  status:z.nativeEnum(StatusEnumSchema).optional()
});
